import instance from "../../../shared/components/auth/service/AxiosInstance";
import { Jwt } from "../../../shared/components/auth/jwt/Jwt";

export const ClientService = {
  getClients: (pageNo, pageSize, research) =>
    instance.get(
      process.env.REACT_APP_API_URL +
        "client/?pageSize=" +
        pageSize +
        "&pageNo=" +
        pageNo +
        "&research=" +
        research,
    ),

  getClientById: (clientId) =>
    instance.get(
      process.env.REACT_APP_API_URL +
        "client/" +
        clientId
    ),

  getClientPresences: (pageNo, pageSize, id, dateStart, dateEnd) =>
    instance.get(
      process.env.REACT_APP_API_URL +
        "presence/client/?pageSize=" +
        pageSize +
        "&pageNo=" +
        pageNo +
        "&id=" +
        id +
        ((dateStart.length > 0) ? ("&dateStart=" + dateStart) : '') +
        ((dateEnd.length > 0) ? ("&dateEnd=" + dateEnd) : '')
        ,
    ),


  getClientAllPresences: (pageNo, pageSize, id) =>
    instance.get(
      process.env.REACT_APP_API_URL +
        "presence/client/" +
        id +
        "?pageSize=" +
        pageSize +
        "&pageNo=" +
        pageNo,
  ),

  getClientContract: (pageNo, pageSize, id) =>
    instance.get(
      process.env.REACT_APP_API_URL +
        "contract/client/?pageSize=" +
        pageSize +
        "&pageNo=" +
        pageNo +
        "&id=" +
        id,
    ),

  getClientExclusion: (pageNo, pageSize, id) =>
    instance.get(
      process.env.REACT_APP_API_URL +
        "exclusion/client/" +
        id +
        "?pageSize=" +
        pageSize +
        "&pageNo=" +
        pageNo,
    ),

  getClientsTUCBySite: (date, siteId) => 
    instance.get(process.env.REACT_APP_API_URL + "client/ATI/site/" + siteId + "/date/" + date),

  createClient: (client) => {
    const { street, ...rest } = client;
    const payload = {
      ...rest,
      street: (typeof street === "object") ? street?.value : client?.street,
    };
    return instance.post(process.env.REACT_APP_API_URL + "client/", payload, 
  )},

  updateClient: (id, client) => {
    const { street, ...rest } = client;
    const payload = {
      ...rest,
      street: (typeof street === "object") ? street?.value : client?.street,
    };
    return instance.put(process.env.REACT_APP_API_URL + "client/" + id, payload);
  },

  deleteClient: (id) =>
    instance.delete(process.env.REACT_APP_API_URL + "client/" + id),

  mergeClients: (clientToRemoveId, clientToKeepId) =>
    instance.post(process.env.REACT_APP_API_URL + "client/merge/keep",
      {
        clientToRemoveId: clientToRemoveId,
        clientToKeepId: clientToKeepId
      }
    ),

  updateClientResidenceInformations: (id, resident, address, sdf) =>
    instance.put(process.env.REACT_APP_API_URL + "client/" + id + "/resident", 
      {
        resident: resident,
        address: {
          streetNumber: address?.streetNumber,
          street: ((typeof address?.street === "object") ? address?.street?.name : address?.street),
          zipcode: address?.zipcode,
          locality: address?.locality,
          municipality: address?.municipality
        },
        sdf: sdf,
      }
    ),

  updateClientResidenceCountry: (id, resident, countryId, sdf) =>
    instance.put(process.env.REACT_APP_API_URL + "client/" + id + "/resident/country", 
      {
        resident: resident,
        countryId: countryId,
        sdf: sdf,
      }
    ),
    
  updateClientSdfStatus: (id, resident, sdf) =>
      instance.put(process.env.REACT_APP_API_URL + "client/" + id + "/sdf", 
        {
          resident: resident,
          sdf: sdf,
        }
      ),
};
